import { memo } from 'react';
import Pressable from "../../../other/Pressable";

const BotoExportar = memo(({ disabled }) => {
    const share_link = window.location.href.replace("edit/", "").replace("edit", "");

    return (
        <Pressable id="exportar-container" 
            style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }} 
            className={`boto boto-save ${disabled ? 'disabled' : ''}`}
        >
            <a style={{ textDecoration: 'none' }} href={share_link} target='_blank'>
                📽️
            </a>
        </Pressable>
    );
}, (prevProps, nextProps) => prevProps.disabled === nextProps.disabled);

export default BotoExportar;